import React from 'react';
import { useNavigate } from "react-router-dom";
import ActionBox from './ActionBox';
import { useProjectConfigContext } from '../../../contexts/ProjectConfigContext';
import style from '../style.module.css';


const ActionBoxContainer = () => {

    const navigate = useNavigate();
    const { projectConfigState } = useProjectConfigContext();


    const projectId = projectConfigState.projectId;
    const homePageConfig = projectConfigState.homePageConfig;


    return (
        <div className={style.actionBoxContainer}>
            <ActionBox onClick={() => navigate(`/permit-request/${projectId}`)}
                portalAction='ADD_PERMIT_REQUEST' />
            <ActionBox portalAction='ADD_FILE_TO_REQUEST' />
            <ActionBox portalAction='CHECK_REQUEST_STATUS' />

            {homePageConfig.hasCancelPermitOption ? (
                <ActionBox portalAction='CANCEL_PERMIT' />
            ) : ''}

            <ActionBox portalAction='CHECK_PEMIT_VALIDITY' />

            {homePageConfig.hasUpdateVehicleDetailsOption ? (
                <ActionBox portalAction='UPDATE_VEHICLE_DETAILS' />
            ) : ''}
            
            {homePageConfig.hasRenewedPermitOption ? (
                <ActionBox portalAction='RENEWED_PERMIT_OPTION' />
            ) : ''}

        </div>
    );

}

export default ActionBoxContainer;